import React from 'react'

import { Shine } from './stylesEmphasisPrhase'


export function EmphasisPhrase() {
  return <Shine>Começou a liquida verão !</Shine>

}
